export default __webpack_public_path__ + "869888415d0b1a99ae5c7ac7c4575ccf.woff2";